/** Set by nginx from Cloudflare: `user_country=$http_cf_ipcountry` */
export const USER_COUNTRY_COOKIE_NAME = 'user_country'

export function getUserCountryFromCookie(): string | null {
  if (typeof document === 'undefined') return null
  const escaped = USER_COUNTRY_COOKIE_NAME.replace(
    /[.*+?^${}()|[\]\\]/g,
    '\\$&',
  )
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`))
  if (!match?.[1]) return null
  try {
    return decodeURIComponent(match[1]).trim() || null
  } catch {
    return match[1].trim() || null
  }
}

/** Only Brazil is allowed for self-serve checkout; any other country (or missing cookie) → `/payment-blocked`. */
export function isPaymentBlockedByUserCountryCookie(): boolean {
  const code = getUserCountryFromCookie()?.toUpperCase()
  return code !== 'BR'
}
